// extracted by mini-css-extract-plugin
module.exports = {"error":"password-protection_error__Q4CZj"};